var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("object", {
    style: { color: `${_vm.color}` },
    attrs: {
      type: "image/svg+xml",
      data: require(`@/assets/icons/${_vm.icon}.svg`),
      width: `${_vm.width}`,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }